import { Injectable, Injector } from "@angular/core";
import { PreguntaDTO, RespuestaUsuario } from "@DTOS";
import { Respuesta } from "../../../../../../layout/investigaciones/ver-respuestas/Respuesta";
import { CloudData } from "angular-tag-cloud-module";
import { FiltrosService } from "../../../../../../layout/investigaciones/ver-respuestas/filtros.service";
import { obtenerNombreGenero, obtenerNombreRangoEdad, TipoCacheRespuestaEnum } from "@shared/enums";
import { CacheRespuestas } from "../CacheRespuestas";
import { FiltroRespuesta } from "../../../../../../layout/investigaciones/ver-respuestas/Filtro.respuestas";
import { ObtenerRespuestas } from "./ObtenerRespuestas";
import { Store } from "@ngxs/store";

@Injectable({
    providedIn: "root"
})
export class ObtenerRespuestasComparativa extends ObtenerRespuestas {
    constructor(private filtrosService: FiltrosService, cacheRespuestas: CacheRespuestas,
        store: Store, injector: Injector
    ) {
        super(store, cacheRespuestas, injector);
    }

    public async obtenerRespuestas(
        pregunta: PreguntaDTO, respuestas: RespuestaUsuario[]
    ): Promise<Respuesta[] | CloudData[]> {
        const filtroComparativo = this.filtrosService.obtenerComparativo();
        if (filtroComparativo == null) {
            return [];
        }
        const itemsFiltros = this.filtrarItemsEnFiltro(filtroComparativo);
        const datosGrafico: Respuesta[] = [];

        await Promise.all(itemsFiltros.map(async respuestaEje => {
            const respuestasFiltradasItem = this.filtrarRespuestasPorItem(respuestas, filtroComparativo, respuestaEje);
            const respuestasPregunta = this.obtenerRespuestasProcesoDatos(
                pregunta, respuestasFiltradasItem
            );
            datosGrafico.push({
                name: respuestaEje.name,
                series: respuestasPregunta.filter(Boolean)
            });
        }));
        return datosGrafico;
    }

    private filtrarRespuestasPorItem(
        respuestas: RespuestaUsuario[], filtro: FiltroRespuesta, itemFiltro: Respuesta
    ): RespuestaUsuario[] {
        switch (filtro?.pregunta.texto) {
        case "Rangos de edad":
        case "edad":
            return respuestas.filter(respuesta =>
                respuesta.rangoEdad != null && obtenerNombreRangoEdad(respuesta.rangoEdad) === itemFiltro.name
            );
        case "Géneros":
        case "genero":
            return respuestas.filter(respuesta =>
                respuesta.genero != null && obtenerNombreGenero(respuesta.genero) === itemFiltro.name
            );
        case "Países":
        case "pais":
            return respuestas.filter(respuesta =>
                respuesta.pais != null && respuesta.pais.nombre === itemFiltro.name
            );
        default:
            return [];
        }
    }

    private filtrarItemsEnFiltro(filtroComparativo: FiltroRespuesta): Respuesta[] {
        let itemsEjes = this.obtenerItemsEjes(filtroComparativo);
        const filtrosDeEje = this.filtrosService.obtenerFiltros().filter(filtroDTO =>
            filtroComparativo.pregunta.texto === filtroDTO.pregunta.texto && !filtroDTO.esComparativa);
        if (filtrosDeEje.length > 0) {
            const respuestasNueva: Respuesta[] = [];

            filtrosDeEje.forEach(filtroDeEje => {
                const respuestaEjeFiltro = itemsEjes.find(respuestaEje =>
                    respuestaEje.name === filtroDeEje.item.texto);

                if (respuestaEjeFiltro != null) {
                    respuestasNueva.push(respuestaEjeFiltro);
                }
            });

            itemsEjes = respuestasNueva;
        }
        return itemsEjes;
    }

    private obtenerItemsEjes(filtroComparativo: FiltroRespuesta): Respuesta[] {
        switch (filtroComparativo?.pregunta.texto) {
        case "Rangos de edad":
        case "edad":
            return this.cacheRespuestas.obtenerRespuestas(TipoCacheRespuestaEnum.RANGOS_EDAD);
        case "Géneros":
        case "genero":
            return this.cacheRespuestas.obtenerRespuestas(TipoCacheRespuestaEnum.GENEROS);
        case "Países":
        case "pais":
            return this.cacheRespuestas.obtenerRespuestas(TipoCacheRespuestaEnum.PAISES);
        case "Por día":
        default:
            return [];
        }
    }
}
